import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { caption, captionBold, colors, spacing, mediumShadow } from 'ui/theme';
import { TopTooltip } from 'ui/tooltip';

const customSpacing = {
  height: pxToRem(40),
};

export const AudienceBreakdownChartWrapper = styled.div`
  display: flex;
  gap: ${spacing.eighth};
  width: 100%;
  align-items: stretch;
`;

export const ChartSection = styled.div<{ percent: number; isTooltipEnabled: boolean }>`
  height: 100%;
  flex: ${(props) => props.percent}%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
  &:hover {
    box-shadow: ${(props) => (props.isTooltipEnabled ? mediumShadow.boxShadow : 'none')};
    cursor: ${(props) => (props.isTooltipEnabled ? 'pointer' : 'default')};
  }
`;

export const TopBlockGroup = styled.div`
  display: flex;
  gap: ${spacing.eighth};
  height: ${spacing.double};
`;

export const TopBlock = styled.span<{
  color: string;
  backgroundColor: string;
  borderColor: string;
  first: boolean;
  last: boolean;
}>`
  ${caption};
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  padding: ${spacing.half} 0;
  color: ${(props) => props.color};
  background-color: ${(props) => props.backgroundColor};
  border: 1px solid ${(props) => props.borderColor};
  border-top-left-radius: ${(props) => (props.first ? '4px' : '0px')};
  border-top-right-radius: ${(props) => (props.last ? '4px' : '0px')};
`;

export const BottomBlock = styled.div<{
  first: boolean;
  last: boolean;
  percent: number;
}>`
  ${caption};
  display: flex;
  flex-direction: column;
  color: ${colors.grey15};
  background-color: ${colors.grey1};
  border-radius: 0px 0px 4px 4px;
  border-right: 1px solid ${colors.grey15};
  border-bottom: 1px solid ${colors.grey15};
  border-left: 1px solid ${colors.grey15};
  height: ${customSpacing.height};
  padding: ${(props) =>
    props.percent < 5 ? 0 : `${spacing.quarter} 0 ${spacing.quarter} ${spacing.half}`};
  border-bottom-left-radius: ${(props) => (props.first ? '4px' : '0px')};
  border-bottom-right-radius: ${(props) => (props.last ? '4px' : '0px')};
`;

export const GroupLabel = styled.div`
  color: ${colors.secondaryText};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const GroupValues = styled.div`
  display: flex;
`;

export const PercentValue = styled.div`
  ${captionBold};
  color: ${colors.textPrimary};
`;

export const TotalValue = styled.div`
  ${captionBold};
  color: ${colors.secondaryText};
  padding-left: ${spacing.quarter};
`;

export const StyledTopTooltip = styled(TopTooltip)`
  width: 100%;
`;

export const TooltipVariantCircle = styled.div<{ backgroundColor: string; borderColor: string }>`
  background-color: ${(props) => props.backgroundColor};
  border: 1px solid ${(props) => props.borderColor};
  border-radius: 50%;
  width: ${spacing.half};
  height: ${spacing.half};
  margin-right: ${spacing.half};
`;

export const TooltipVariantLetter = styled.div`
  margin-right: ${spacing.base};
`;

export const AudienceBreakdownTooltipWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AudienceBreakdownBaseRow = styled.div`
  ${captionBold};
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${spacing.base};
`;

export const AudienceBreakdownTooltipRow = styled(AudienceBreakdownBaseRow)<{ first: boolean }>`
  padding-top: ${(props) => (props.first ? spacing.half : spacing.quarter)};
`;

export const AudienceBreakdownTooltipHeader = styled(AudienceBreakdownBaseRow)`
  padding-top: 0;
`;

export const TooltipLabel = styled.div`
  color: ${colors.grey15};
`;

export const TooltipMetrics = styled.div`
  color: ${colors.white};
  display: flex;
  align-items: center;
`;
